// extracted by css-extract-rspack-plugin
export default {"ApplicationAgreements":"sputnik__ApplicationAgreements__pnyKm","applicationAgreements":"sputnik__ApplicationAgreements__pnyKm"};